import { Icon, Text } from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';
import React from 'react';

import translations from 'src/lang';

const translation = translations['en-US'];

const StyledEmptyRepositoryCampaignContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;

  & > p {
    white-space: pre-line;
    text-align: center;
    padding: 0.75rem;
  }
`;

export const EmptyRepositoryCampaignContainer = () => {
  return (
    <StyledEmptyRepositoryCampaignContainer>
      <Icon icon="icon-play" size="xlarge" variant="secondary" />
      <Text size="xbody" variant="dark">
        {translation.REPOSITORY.AUDIENCE_ACTIVATION.EMPTY_CAMPAIGN_TEXT}
      </Text>
    </StyledEmptyRepositoryCampaignContainer>
  );
};
